<div class="lost-network-connection-container" *ngIf="showNetworkPageFound">
  <img src="assets/generalImage/404_error.svg" alt="mascot"/>
  <h1>{{'lost.network.connection.title.1' | translate}}</h1>

  <app-button [buttonName]="'button.refresh'" (onClickEvent)="reload()" class="refresh-btn"></app-button>
</div>
